import { defineComponent as t, resolveComponent as p, createElementBlock as r, openBlock as o, normalizeClass as l, createCommentVNode as s, createElementVNode as f, renderSlot as d, createBlock as n } from "vue";
import { D as k } from "./DIcon-DTQWfP1x.js";
import { E as u, b, a as $ } from "./const-CBRa5y2-.js";
import "./cloneDeep-BpI9WtaE.js";
import { n as c } from "./index.browser-CWCjzKuA.js";
import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import './assets/DFormField-DTM19TOo.css';var a = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.SMALL = "small", e))(a || {});
const E = t({
  compatConfig: {
    MODE: 3
  },
  components: {
    DIcon: k
  },
  props: {
    clearable: Boolean,
    blocked: Boolean,
    disabled: Boolean,
    dark: Boolean,
    error: Boolean,
    size: { type: String, default: () => a.LARGE },
    loading: Boolean,
    focused: Boolean,
    hasValue: Boolean,
    hideLabelOnFocus: Boolean,
    id: { type: String, default: () => c() }
  },
  emits: ["clear", "click"],
  setup(e, { emit: _ }) {
    return {
      EIconColor: $,
      ESize: a,
      EIcon: b,
      EIconSize: u,
      onClear: () => {
        _("clear");
      }
    };
  }
}), I = "_spin_118fk_1", C = {
  "d-form-field": "_d-form-field_118fk_7",
  "d-form-field_state-focused": "_d-form-field_state-focused_118fk_55",
  "d-form-field_state-error": "_d-form-field_state-error_118fk_58",
  "d-form-field_state-disabled": "_d-form-field_state-disabled_118fk_58",
  "d-form-field_color-dark": "_d-form-field_color-dark_118fk_68",
  "d-form-field_size-small": "_d-form-field_size-small_118fk_80",
  "d-form-field_size-small_with-label": "_d-form-field_size-small_with-label_118fk_80",
  "d-form-field__control": "_d-form-field__control_118fk_91",
  "d-form-field__control-field": "_d-form-field__control-field_118fk_100",
  "d-form-field__control-left": "_d-form-field__control-left_118fk_106",
  "d-form-field__control-right": "_d-form-field__control-right_118fk_110",
  "d-form-field__prepend": "_d-form-field__prepend_118fk_114",
  "d-form-field__append": "_d-form-field__append_118fk_118",
  "d-form-field__label": "_d-form-field__label_118fk_122",
  "d-form-field__label_ontop": "_d-form-field__label_ontop_118fk_139",
  "d-form-field__label_transparent": "_d-form-field__label_transparent_118fk_143",
  "d-form-field__bg": "_d-form-field__bg_118fk_149",
  "d-form-field__outline": "_d-form-field__outline_118fk_158",
  "d-form-field__icon": "_d-form-field__icon_118fk_169",
  "d-form-field__icon-clearable": "_d-form-field__icon-clearable_118fk_172",
  "d-form-field__icon_spin": "_d-form-field__icon_spin_118fk_175",
  spin: I,
  "d-form-field__messages": "_d-form-field__messages_118fk_186",
  "d-form-field__under": "_d-form-field__under_118fk_194"
}, z = ["dsiabled", "readonly", "for"];
function g(e, _, m, h, v, B) {
  const i = p("DIcon");
  return o(), r("div", {
    class: l({
      [e.$style["d-form-field"]]: !0,
      [e.$style["d-form-field_state-focused"]]: e.focused,
      [e.$style["d-form-field_state-disabled"]]: e.disabled,
      [e.$style["d-form-field_state-error"]]: e.error,
      [e.$style["d-form-field_color-dark"]]: e.dark,
      [e.$style["d-form-field_size-small"]]: e.size === e.ESize.SMALL,
      [e.$style["d-form-field_size-small_with-label"]]: !e.hideLabelOnFocus
    })
  }, [
    e.$slots.prepend ? (o(), r("div", {
      key: 0,
      class: l(e.$style["d-form-field__prepend"])
    }, [
      d(e.$slots, "prepend")
    ], 2)) : s("", !0),
    e.$slots.append ? (o(), r("div", {
      key: 1,
      class: l(e.$style["d-form-field__append"])
    }, [
      d(e.$slots, "append")
    ], 2)) : s("", !0),
    f("div", {
      class: l(e.$style["d-form-field__control"])
    }, [
      f("div", {
        class: l(e.$style["d-form-field__bg"])
      }, null, 2),
      f("div", {
        class: l(e.$style["d-form-field__control-field"])
      }, [
        d(e.$slots, "control", { id: e.id }),
        f("label", {
          class: l({
            [e.$style["d-form-field__label"]]: !0,
            [e.$style["d-form-field__label_ontop"]]: e.focused || e.hasValue,
            [e.$style["d-form-field__label_transparent"]]: e.hideLabelOnFocus && (e.focused || e.hasValue)
          }),
          dsiabled: e.disabled,
          readonly: e.blocked,
          for: e.id
        }, [
          d(e.$slots, "label", { for: e.id })
        ], 10, z)
      ], 2),
      e.$slots.innerPrepend ? (o(), r("div", {
        key: 0,
        class: l(e.$style["d-form-field__control-left"])
      }, [
        d(e.$slots, "innerPrepend")
      ], 2)) : s("", !0),
      e.$slots.innerAppend || e.blocked || e.disabled || e.loading || e.clearable ? (o(), r("div", {
        key: 1,
        class: l(e.$style["d-form-field__control-right"])
      }, [
        e.blocked || e.disabled ? (o(), n(i, {
          key: 0,
          class: l({
            [e.$style["d-form-field__icon"]]: !0
          }),
          name: e.EIcon.SAFETY_SAFETY,
          size: e.EIconSize.S_16,
          color: e.disabled || !e.dark && e.blocked ? e.EIconColor.GREY_284 : e.EIconColor.WHITE_101,
          bold: ""
        }, null, 8, ["class", "name", "size", "color"])) : e.loading ? (o(), n(i, {
          key: 1,
          class: l({
            [e.$style["d-form-field__icon"]]: !0,
            [e.$style["d-form-field__icon_spin"]]: !0
          }),
          name: e.EIcon.LOADERS_DEFAULT,
          size: e.EIconSize.S_16,
          color: e.dark ? e.EIconColor.WHITE_101 : e.EIconColor.PRIMARY
        }, null, 8, ["class", "name", "size", "color"])) : e.clearable ? (o(), n(i, {
          key: 2,
          class: l({
            [e.$style["d-form-field__icon"]]: !0,
            [e.$style["d-form-field__icon-clearable"]]: !0
          }),
          name: e.EIcon.CHECK_CLOSE,
          size: e.EIconSize.S_16,
          color: e.dark ? e.EIconColor.WHITE_101 : e.EIconColor.GREY_1514,
          bold: "",
          onClick: e.onClear
        }, null, 8, ["class", "name", "size", "color", "onClick"])) : s("", !0),
        d(e.$slots, "innerAppend")
      ], 2)) : s("", !0),
      f("div", {
        class: l(e.$style["d-form-field__outline"])
      }, null, 2)
    ], 2),
    e.$slots.under ? (o(), r("div", {
      key: 2,
      class: l(e.$style["d-form-field__under"])
    }, [
      d(e.$slots, "under")
    ], 2)) : s("", !0),
    e.$slots.messages && !e.disabled ? (o(), r("div", {
      key: 3,
      class: l(e.$style["d-form-field__messages"])
    }, [
      d(e.$slots, "messages")
    ], 2)) : s("", !0)
  ], 2);
}
const S = {
  $style: C
}, O = /* @__PURE__ */ y(E, [["render", g], ["__cssModules", S]]);
export {
  O as D,
  a as E
};
